import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SupportConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getPtaStringEndpoint(): string {
		return this.service.get((x) => x.core.support.endpoints!.ptaString, "v1/support/chats/ptastring");
	}
}
